import $ from 'jquery';

$(function () {
  if ($('.text.index').length) {
    var buildTable = function (data, $eleToAppend) {
      data.forEach(function (phrase) {
        var $content = $('<tr>');
        $content.append($('<td>', { text: phrase[0] }));
        $content.append(
          $('<td>', { text: parseFloat(phrase[1][0]).toFixed(2) }),
        );
        $content.append($('<td>', { text: phrase[1][1] }));
        $eleToAppend.append($content);
      });
    };

    var appendData = function (id, data) {
      var $employee = $('#' + id);
      var $positive = $employee.next().find('.js-positive');
      var $negative = $employee.next().find('.js-negative');
      buildTable(data.negative, $negative);
      buildTable(data.positive, $positive);
    };

    var fetchData = function (query) {
      $.ajax({
        type: 'get',
        dataType: 'json',
        url: window.location.pathname,
        data: query,
        success: function (data) {
          appendData(query.employee_id, data);
        },
      });
    };

    var params = new window.URLSearchParams(window.location.search);
    var startDate = params.get('start_date');
    var endDate = params.get('end_date');
    $('.js-employee-text-ids').each(function (_, e) {
      var eid = e.dataset.employeeId;
      var query = { employee_id: eid };
      if (startDate) {
        query.start_date = startDate;
      }
      if (endDate) {
        query.end_date = endDate;
      }

      fetchData(query);
    });
  }
});
